import { render, staticRenderFns } from "./CardMaquinaLogis.vue?vue&type=template&id=6fc684bb&scoped=true&"
import script from "./CardMaquinaLogis.vue?vue&type=script&lang=js&"
export * from "./CardMaquinaLogis.vue?vue&type=script&lang=js&"
import style0 from "./CardMaquinaLogis.vue?vue&type=style&index=0&id=6fc684bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc684bb",
  null
  
)

export default component.exports